import { setAnalytics, isDuplicatePageError } from '../../../thd-analytics-utils';
import {
  ACCOUNT,
  ACCOUNT_PROFILE,
  ACCOUNT_PROFILE_PAGE_TYPE
} from '../../../constants';

export function profile() {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('profile.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: ACCOUNT_PROFILE,
        pageType: ACCOUNT_PROFILE_PAGE_TYPE
      },
      category: {
        primaryCategory: ACCOUNT,
        subCategory1: ACCOUNT_PROFILE,
        subCategory2: ACCOUNT_PROFILE
      },
      error: []
    };

    setAnalytics(digitalData);
  });

  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('profile.page-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output || {};

    const pageError = {
      type,
      displayType,
      pageSection,
      message,
      code
    };

    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });
}
